 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9":"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9","accounting-dashboard":"accounting-dashboard","am-commission":"am-commission","analytics~clients-settings~project-settings~settings":"analytics~clients-settings~project-settings~settings","clients-settings":"clients-settings","invoices~project-settings":"invoices~project-settings","project-settings":"project-settings","settings":"settings","analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log":"analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log","analytics~lead-center-activities~lead-center-contacts":"analytics~lead-center-activities~lead-center-contacts","analytics":"analytics","clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm":"clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm","clients-settings-ae":"clients-settings-ae","clients-settings-am":"clients-settings-am","clients-settings-am-supervisor":"clients-settings-am-supervisor","clients-settings-pm":"clients-settings-pm","expenses-backlink~expenses-content~expenses-ppc":"expenses-backlink~expenses-content~expenses-ppc","expenses-backlink":"expenses-backlink","expenses-content":"expenses-content","expenses-ppc":"expenses-ppc","invoices":"invoices","lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280":"lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280","lead-center-activities":"lead-center-activities","lead-center-contacts":"lead-center-contacts","lead-center-settings-forms":"lead-center-settings-forms","lead-center-kpi":"lead-center-kpi","lead-center-overview":"lead-center-overview","team-time-log~weekly-log":"team-time-log~weekly-log","team-time-log":"team-time-log","applications-settings":"applications-settings","forgot-password":"forgot-password","gpt":"gpt","lead-center-workflow":"lead-center-workflow","lead-center-workflows":"lead-center-workflows","login":"login","profile":"profile","register":"register","reset-password":"reset-password","weekly-log":"weekly-log"}[chunkId]||chunkId) + "." + {"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9":"7b0a64e2","accounting-dashboard":"0f31b25b","am-commission":"13e77294","analytics~clients-settings~project-settings~settings":"84780974","clients-settings":"4a2a3309","invoices~project-settings":"2b07944a","project-settings":"3427aefb","settings":"1f41d5bc","analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log":"76e7f2aa","analytics~lead-center-activities~lead-center-contacts":"e465744f","analytics":"ecdaceab","clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm":"10c48d86","clients-settings-ae":"9e7abc9a","clients-settings-am":"9a0fb259","clients-settings-am-supervisor":"ff0b4c88","clients-settings-pm":"e4e337d2","expenses-backlink~expenses-content~expenses-ppc":"618dc3b3","expenses-backlink":"99adddea","expenses-content":"ea4c3ef6","expenses-ppc":"0b6d161a","invoices":"805c7b10","lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280":"c979a10e","lead-center-activities":"54e35978","lead-center-contacts":"05144e0b","lead-center-settings-forms":"ef9ac4fc","lead-center-kpi":"76899df8","lead-center-overview":"5f4acaa1","team-time-log~weekly-log":"af51bfea","team-time-log":"ebb62220","applications-settings":"17e7f29c","forgot-password":"f8069294","gpt":"987709f1","lead-center-workflow":"0c1a2e7d","lead-center-workflows":"abd27a45","login":"81073874","profile":"8027a33d","register":"8ca3ddc0","reset-password":"2ac0b14c","weekly-log":"80f2b5c8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9":1,"accounting-dashboard":1,"am-commission":1,"analytics~clients-settings~project-settings~settings":1,"clients-settings":1,"invoices~project-settings":1,"project-settings":1,"settings":1,"analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log":1,"analytics~lead-center-activities~lead-center-contacts":1,"analytics":1,"clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm":1,"expenses-backlink~expenses-content~expenses-ppc":1,"invoices":1,"lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280":1,"lead-center-activities":1,"lead-center-contacts":1,"lead-center-settings-forms":1,"lead-center-kpi":1,"lead-center-overview":1,"team-time-log~weekly-log":1,"team-time-log":1,"forgot-password":1,"gpt":1,"lead-center-workflow":1,"lead-center-workflows":1,"login":1,"profile":1,"register":1,"reset-password":1,"weekly-log":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9":"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9","accounting-dashboard":"accounting-dashboard","am-commission":"am-commission","analytics~clients-settings~project-settings~settings":"analytics~clients-settings~project-settings~settings","clients-settings":"clients-settings","invoices~project-settings":"invoices~project-settings","project-settings":"project-settings","settings":"settings","analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log":"analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log","analytics~lead-center-activities~lead-center-contacts":"analytics~lead-center-activities~lead-center-contacts","analytics":"analytics","clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm":"clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm","clients-settings-ae":"clients-settings-ae","clients-settings-am":"clients-settings-am","clients-settings-am-supervisor":"clients-settings-am-supervisor","clients-settings-pm":"clients-settings-pm","expenses-backlink~expenses-content~expenses-ppc":"expenses-backlink~expenses-content~expenses-ppc","expenses-backlink":"expenses-backlink","expenses-content":"expenses-content","expenses-ppc":"expenses-ppc","invoices":"invoices","lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280":"lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280","lead-center-activities":"lead-center-activities","lead-center-contacts":"lead-center-contacts","lead-center-settings-forms":"lead-center-settings-forms","lead-center-kpi":"lead-center-kpi","lead-center-overview":"lead-center-overview","team-time-log~weekly-log":"team-time-log~weekly-log","team-time-log":"team-time-log","applications-settings":"applications-settings","forgot-password":"forgot-password","gpt":"gpt","lead-center-workflow":"lead-center-workflow","lead-center-workflows":"lead-center-workflows","login":"login","profile":"profile","register":"register","reset-password":"reset-password","weekly-log":"weekly-log"}[chunkId]||chunkId) + "." + {"accounting-dashboard~am-commission~analytics~clients-settings~clients-settings-ae~clients-settings-a~b9f477b9":"f8ac3c74","accounting-dashboard":"7262c815","am-commission":"008e9b25","analytics~clients-settings~project-settings~settings":"c9126f35","clients-settings":"89c40add","invoices~project-settings":"cc179630","project-settings":"5ba702c3","settings":"5ba702c3","analytics~lead-center-activities~lead-center-contacts~lead-center-settings-forms~team-time-log":"6460069a","analytics~lead-center-activities~lead-center-contacts":"e4d6716c","analytics":"90320c70","clients-settings-ae~clients-settings-am~clients-settings-am-supervisor~clients-settings-pm":"470ca8ba","clients-settings-ae":"31d6cfe0","clients-settings-am":"31d6cfe0","clients-settings-am-supervisor":"31d6cfe0","clients-settings-pm":"31d6cfe0","expenses-backlink~expenses-content~expenses-ppc":"5ba702c3","expenses-backlink":"31d6cfe0","expenses-content":"31d6cfe0","expenses-ppc":"31d6cfe0","invoices":"3ee64fe1","lead-center-activities~lead-center-contacts~lead-center-kpi~lead-center-overview~lead-center-setting~85c56280":"7059ab6e","lead-center-activities":"a5f15518","lead-center-contacts":"8161cd2e","lead-center-settings-forms":"e4aa4041","lead-center-kpi":"249c0bb1","lead-center-overview":"fcbac52d","team-time-log~weekly-log":"5ba702c3","team-time-log":"d4a73e69","applications-settings":"31d6cfe0","forgot-password":"daa2a4fb","gpt":"6838850a","lead-center-workflow":"7edc0638","lead-center-workflows":"313f1195","login":"32fa4315","profile":"ba113455","register":"aaea3f6a","reset-password":"e50377a1","weekly-log":"5c33402c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
